<mat-drawer-container style="height: 100%">
  <mat-drawer-content style="background: white">
    <h3>体測実施内容</h3>
    <div class="left-pane">
      <table class="event-list">
        <thead>
        <tr>
          <th>予定日</th>
          <th>日齢</th>
          <th>対象のロット</th>
        </tr>
        </thead>
        <tbody *ngIf="selectedMeisais && selectedMeisais.length > 0">
        <tr *ngFor="let event of selectedMeisais;">
          <td>{{event?.yoteiDate}}</td>
          <td>{{event.yoteiNichirei}}</td>
          <td>{{event.taishouLotName}}</td>
        </tr>
        </tbody>
      </table>
      <br>
<!--      <div fxLayout="row wrap" fxLayoutGap="10px">-->
<!--        <mat-slide-toggle style="margin-left: 20px;" [(ngModel)]="editEvent">予定日を編集する</mat-slide-toggle>-->
<!--      </div>-->
      <form #jisshiForm="ngForm" *ngIf="!editEvent">
        <div fxLayout="row wrap" fxLayoutGap="10px">
          <mat-form-field appearance="legacy" style="padding-bottom: 10px">
            <mat-label>実施日</mat-label>
            <input matInput [matDatepicker]="jisshiDatePicker" [(ngModel)]="inputForm.jisshiDate" name="jisshiDate" readonly
                   (click)="jisshiDatePicker.open()" (dateChange)="eventService.updateJisshiNichirei2(inputForm, edukeDate)">
            <mat-datepicker-toggle matSuffix [for]="jisshiDatePicker"></mat-datepicker-toggle>
            <mat-datepicker touchUi #jisshiDatePicker disabled="false"></mat-datepicker>
          </mat-form-field>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="10px">
          <mat-form-field>
            <mat-label>
              実施日齢
            </mat-label>
            <input matInput placeholder="実施日齢" required disabled
                   name="jisshiNichirei"
                   [(ngModel)]="inputForm.jisshiNichirei">
          </mat-form-field>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="10px">
          <mat-form-field>
            <mat-label>
              平均体重(g)
            </mat-label>
            <input matInput placeholder="平均体重(g)" required
                   name="mean" [(ngModel)]="inputForm.mean">
          </mat-form-field>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="10px">
          <mat-form-field>
            <mat-label>
              CV
            </mat-label>
            <input matInput placeholder="CV" required
                   name="cv" [(ngModel)]="inputForm.cv">
          </mat-form-field>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="10px">
          <mat-form-field>
            <mat-label>
              実施者
            </mat-label>
            <input matInput placeholder="実施者" required
                   name="jisshiSha" [(ngModel)]="inputForm.jisshiSha">
          </mat-form-field>
        </div>
        <br>
        <div fxLayout="row wrap" fxLayoutGap="12px" style="margin-bottom: 12px">
          <div [matTooltip]="commonService.getAlertTooltipMessage(jisshiForm)"
               matTooltipPosition="below"
               style="width: fit-content">
            <button mat-raised-button color="primary" [disabled]="jisshiForm.invalid"
                    (click)="register();">登録
            </button>
          </div>
          <div [matTooltip]="!selectedMeisais[0].jisshiDate ? '実施内容が登録されていません。' : ''"
               matTooltipPosition="below"
               style="width: fit-content">
            <button mat-raised-button color="accent"
                    [disabled]="!selectedMeisais[0].jisshiDate"
                    (click)="undo();">取り消し
            </button>
          </div>
        </div>
      </form>
    </div>
  </mat-drawer-content>
  <mat-drawer style="width: 60%"opened position="end" mode="side">
    <div class="right-pane">
      <div *ngIf="!editEvent">
        <div *ngIf="inputForm.weights">
          <br>
          <mat-expansion-panel>
            <mat-expansion-panel-header>登録済み体測情報</mat-expansion-panel-header>
            <table class="event-list csv">
            <tbody>
            <tr *ngFor="let weight of inputForm.weights;let weightIndex = index">
              <td>{{weightIndex + 1}}</td>
              <td>{{weight}}</td>
            </tr>
            </tbody>
          </table>
          </mat-expansion-panel><br>
        </div>
        <button mat-raised-button color="primary"
                (click)="onClickFileInputButton()"
                style="margin-right: 12px;margin-bottom: 12px">CSV読み込み
        </button>
        <input type="file" hidden #fileInput (change)="onChangeFileInput()"/>
        <div *ngIf="csvService.separatedCsvData">
          <mat-expansion-panel *ngFor="let lotCSVData of csvService.separatedCsvData; let lotIndex = index"
                               [expanded]='lotCSVData.relatedLot === ""'>
            <mat-expansion-panel-header>{{lotCSVData.relatedLot}}</mat-expansion-panel-header>
            <table class="event-list csv" (click)="lotSelected(lotIndex)"
                   [ngClass]="{'selectedLot': selectedLotIndex === lotIndex}">
              <tbody *ngIf="lotCSVData.csv && lotCSVData.csv.length > 0">
              <tr *ngFor="let csvRow of lotCSVData.csv;">
                <td>{{csvRow?.index}}</td>
                <td>{{csvRow.dateStr}}</td>
                <td>{{csvRow.timeStr}}</td>
                <td>{{csvRow?.ST}}</td>
                <td>{{csvRow.weight}}</td>
                <td>{{csvRow.unit}}</td>
              </tr>
              </tbody>
            </table>
          </mat-expansion-panel>
        </div>
      </div>
      <div *ngIf="editEvent">
        <app-event-edit [selectedMeisais]="selectedMeisais"></app-event-edit>
      </div>
    </div>
  </mat-drawer>
</mat-drawer-container>
